import React from "react";
import { configureStore, createListenerMiddleware, combineReducers } from "@reduxjs/toolkit";
import { Provider } from "react-redux";
import rootReducer from "./src/reducers";
import reducerRegistry from "./reducerRegistry";
import { IS_PRODUCTION } from "utils/constants";
import { checkForCartBonus } from "src/actions/cart";

const listenerMiddleWare = createListenerMiddleware();

listenerMiddleWare.startListening({
	predicate: (action) =>
		// Check if the action is a cart action and has been fulfilled AND is not from the bonus source
		// Because we want to ensure that the cart bonus is only checked for regular cart actions
		action.type.startsWith("cart/") && action.type.endsWith("/fulfilled") && action.meta?.arg?.source !== "bonus",
	effect: (_action, api) => {
		api.cancelActiveListeners(); // Cancel any previous listeners to avoid duplicates
		api.dispatch(checkForCartBonus());
	}
});

export default ({ element }) => {
	const store = configureStore({
		reducer: rootReducer,
		devTools: !IS_PRODUCTION,
		middleware: (getDefaultMiddleware) =>
			getDefaultMiddleware({
				serializableCheck: {
					ignoredPaths: ["global.shopifyClient"],
				},
				immutableCheck: true,
			}).prepend(listenerMiddleWare.middleware)
	});

	reducerRegistry.setChangeListener((reducers) => {
		store.replaceReducer(combineReducers(reducers));
	});

	return <Provider store={store}>{element}</Provider>;
};
